export enum NoteType {
  Symptom = 1, // 症状
  Effects = 2, // 薬の影響
  Concerns = 3, // 心配事・困りごと
  Other = 4, // その他
  Questions = 5, // 疑問
  Memo = 6, // メモ
  Conversation = 7, // 診察時に話した内容
}

// 生データ型
export type RawItem = {
  dates: string;
  chartData:
    | { value: number; condition: string; color?: string; size?: number }
    | { value: number; condition: string; color?: string; size?: number }[]
    | null;
};

export type NoteData = {
  input_date: string;
  sub_number: number;
  content: string;
};
